export const CORPORATE_ID_FOLLOW_SAS_LEAD = [
    5, // campbell
]